import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-delivery",
  "use": "icon-soc-delivery-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-delivery\">\r\n<g transform=\"translate(-113.571 -230.865) scale(1.221818)\">\r\n<path d=\"M160 352h448v320H160V352zm64 64v192h320V416H224z\" />\r\n  <path d=\"M640 416h160l64 96v160H640V416zm48 64v128h112v-80l-40-48H688z\" />\r\n  <path d=\"M288 736a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm448 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-delivery.svg
// module id = MnWG
// module chunks = 546